/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const UsersIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3609 19.8958H21.7895V16.1904C21.7894 16.0191 21.738 15.8518 21.6419 15.71C21.5458 15.5682 21.4094 15.4585 21.2503 15.3949L18.0429 14.1092C17.8841 14.0458 17.7479 13.9363 17.6519 13.7949C17.5558 13.6534 17.5042 13.4865 17.5038 13.3155L17.5038 12.5629C18.0236 12.2646 18.4558 11.8346 18.7567 11.3163C19.0576 10.7979 19.2167 10.2095 19.2181 9.61009V7.8958C19.2182 7.2939 19.0599 6.70256 18.759 6.18125C18.4581 5.65993 18.0253 5.22701 17.5041 4.926C16.9829 4.62498 16.3916 4.46649 15.7897 4.46646C15.1878 4.46643 14.5965 4.62485 14.0752 4.9258"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M14.3932 16.2521L11.1858 14.9664C11.027 14.9029 10.8908 14.7935 10.7948 14.652C10.6987 14.5106 10.6471 14.3436 10.6467 14.1727V13.4201C11.1665 13.1218 11.5986 12.6918 11.8996 12.1734C12.2005 11.6551 12.3596 11.0666 12.3609 10.4672L12.3609 8.75294C12.3609 7.84363 11.9997 6.97156 11.3567 6.32858C10.7138 5.68559 9.84169 5.32437 8.93237 5.32437C8.02306 5.32437 7.15099 5.68559 6.50801 6.32858C5.86502 6.97156 5.5038 7.84363 5.5038 8.75294L5.5038 10.4672C5.50511 11.0666 5.66424 11.6551 5.96517 12.1734C6.2661 12.6918 6.69823 13.1218 7.21809 13.4201V14.1727C7.21798 14.3439 7.16656 14.5112 7.07046 14.653C6.97437 14.7948 6.838 14.9045 6.67894 14.9681L3.47152 16.2538C3.31273 16.3172 3.17655 16.4267 3.08048 16.5681C2.9844 16.7096 2.93282 16.8765 2.93237 17.0475L2.93237 19.8958L14.9324 19.8958V17.0475C14.9323 16.8762 14.8808 16.7089 14.7847 16.5671C14.6887 16.4254 14.5523 16.3156 14.3932 16.2521Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
